import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterOutlet } from "@angular/router";
import { ToastComponent } from "./shared/components/toast/toast.component";
import { ToastService, ToastMessage } from "./shared/services/toast.service";
import { Observable } from 'rxjs';

@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    ToastComponent
  ],
  template: `
    <router-outlet></router-outlet>
    
    <!-- Contenedor global de toasts -->
    <div class="fixed top-4 left-3 right-4 z-50 space-y-2">
      <div *ngFor="let toast of toasts$ | async; trackBy: trackByToastId">
        <app-toast
          [show]="true"
          [message]="toast.message"
          [type]="toast.type"
          [duration]="0"
          (onClose)="removeToast(toast.id)">
        </app-toast>
      </div>
    </div>
  `,
  styleUrls: []
})
export class AppComponent implements OnInit {
  title = 'teu-preclients-app';
  toasts$: Observable<ToastMessage[]>;

  constructor(private toastService: ToastService) {
    this.toasts$ = this.toastService.toasts$;
  }

  ngOnInit() {}

  removeToast(id: string) {
    this.toastService.removeToast(id);
  }

  trackByToastId(index: number, toast: ToastMessage): string {
    return toast.id;
  }
}
